import { PagesBulkPublishFormValidationSchema } from '@/modules/Pages';

export const pagesBulkPublishFormValidationSchema: PagesBulkPublishFormValidationSchema = {
  scope: [{ required: true }],
  usageForVariants: [{ required: true, type: 'array', message: 'Оберіть хоча б один тип сторінок' }],
  pageIds: [{ required: true, type: 'array', message: 'Оберіть хоча б одну сторінку' }],
  publishedAt: [{ required: true, message: 'Виберіть дату публікації' }],
};
